import useDownloadLookups from "@/reports/hooks/useDownloadLookups";
import useDownloadSites from "@/reports/hooks/useDownloadSites";

const SetupReports = () => {
  useDownloadLookups();
  useDownloadSites();
  return null;
};

export default SetupReports;
